const isValidEmail = (email) => {
  if (!email || email === '') return false;

  return email.match(/^\S+@\S+\.\S+$/);
};

export default isValidEmail;
